import { IconTypes } from "@/components/icons/types";

export const VARIANT_TYPES = {
  default: "default",
  inline: "inline",
  compact: "compact",
} as const;

export type VariantType = (typeof VARIANT_TYPES)[keyof typeof VARIANT_TYPES];

export interface QuizOption {
  label: string;
  message?: string;
  description?: string;
  value?: string;
  searchFilterValue?: string;
  icon?: IconTypes;
  facetMappings?: Record<string, string>; // Custom facet mappings for options that affect multiple facets
}

export interface QuizSection {
  sectionType: "multiple-choice";
  selectionType?: "single" | "multiple"; // Controls if user can select one or multiple options
  title: string;
  description: string;
  options?: QuizOption[]; // Optional for dynamic sections
  searchFilterKey?: string; // Used for Algolia search filters
  key?: string; // Used for non-searchable questions (e.g., "goal", "format")
  optionsVariant: "basic" | "card";
  stepName?: string; // Step name for analytics tracking
  variantTitles?: Partial<Record<VariantType, string>>; // Variant-specific title overrides
}

export interface QuizConfig {
  sections: QuizSection[];
}

export interface MultipleChoiceProps {
  section: QuizSection;
  dynamicOptions?: QuizOption[]; // For sections with searchFilterKey
  currentAnswer?: string | string[]; // Pre-populate with existing answer
  onAnswer: (answer: string | string[]) => void;
  onBack: () => void;
  onNext: (answer: string | string[]) => void;
  totalSections: number;
  currentSectionIndex: number;
  allAnswers?: Record<string, string | string[]>; // All previous answers for dynamic text
  quizConfig?: QuizConfig; // Full quiz config for label lookups
  isLoadingOptions?: boolean; // Indicates if dynamic options are being fetched
  optionsDisplayMode?: "expand" | "search"; // Controls how to display many options
  variant?: VariantType; // Display variant for embedded entry points
}
